import axios from "axios";

axios.defaults.chaturl = "https://chatapi.nte.ai";
// axios.defaults.chaturl = "https://chatstagingapi.nte.ai";


global.$axios = axios;
global.uri = axios.defaults.chaturl;




